import { render, staticRenderFns } from "./DeliveryLoad.vue?vue&type=template&id=165a74de&scoped=true&"
import script from "./DeliveryLoad.vue?vue&type=script&lang=js&"
export * from "./DeliveryLoad.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryLoad.vue?vue&type=style&index=0&id=165a74de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a74de",
  null
  
)

export default component.exports